import { render } from "./ProductOptionsTable.vue?vue&type=template&id=ae361f3c&scoped=true"
import script from "./ProductOptionsTable.vue?vue&type=script&lang=js"
export * from "./ProductOptionsTable.vue?vue&type=script&lang=js"

import "./ProductOptionsTable.vue?vue&type=style&index=0&id=ae361f3c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Sebastian\\Desktop\\-taptasty-order\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae361f3c"]])

export default __exports__